export const PWA_SERVICE_WORKER_FEATURE_FLAG = 'PWA_SERVICE_WORKER_ENABLED';

export type ActiveFeatureConfigLike =
  | Record<string, unknown>
  | undefined
  | null;

export const isPwaServiceWorkerEnabled = (
  config: ActiveFeatureConfigLike
): boolean => Boolean(config?.[PWA_SERVICE_WORKER_FEATURE_FLAG]);

export const getServiceWorkerPaths = () => {
  const basePath = (process.env.NEXT_PUBLIC_BASE_PATH ?? '').replace(/\/$/, '');
  const swPath = basePath ? `${basePath}/sw.js` : '/sw.js';
  const scope = basePath ? `${basePath}/` : '/';

  return { swPath, scope, basePath };
};

export const registerServiceWorker =
  async (): Promise<ServiceWorkerRegistration> => {
    const { swPath, scope } = getServiceWorkerPaths();

    const existingRegistration = await navigator.serviceWorker.getRegistration(
      scope
    );
    if (existingRegistration) {
      return existingRegistration;
    }

    return navigator.serviceWorker.register(swPath, {
      scope,
      // sw.js is served with Cache-Control: no-store; bypass HTTP cache for updates.
      updateViaCache: 'none'
    });
  };
